import { useState } from "react";
import {
  Alert,
  AlertDescription,
  AlertTitle,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  Stack,
} from "@altimateai/lego";
import { IconInfoCircle, IconChevronDown, IconChevronUp } from "@tabler/icons-react";

export const OktaSetupGuide = () => {
  const [open, setOpen] = useState(false);
  return (
    <Alert variant="info">
      <IconInfoCircle className="al-h-4 al-w-4" />
      <Collapsible open={open} onOpenChange={setOpen}>
        <CollapsibleTrigger asChild>
          <Stack direction="row" className="al-items-center al-gap-1 al-cursor-pointer al-w-full">
            <AlertTitle className="al-m-0">Okta Setup Guide</AlertTitle>
            {open ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />}
          </Stack>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <AlertDescription className="al-mt-2">
            <ol className="al-list-decimal al-pl-4 al-space-y-1 al-text-sm">
              <li>
                In Okta Admin Console, go to{" "}
                <strong>
                  Applications &gt; Your App &gt; Sign On &gt; OpenID Connect ID Token
                </strong>
                .
              </li>
              <li>
                Under <strong>Groups claim</strong>, set the claim type to <strong>Filter</strong>{" "}
                with a regex of <code>.*</code> to include all groups, or use a specific prefix
                filter.
              </li>
              <li>
                The claim name should match the <strong>Group Claim Name</strong> configured above
                (default: &quot;groups&quot;).
              </li>
              <li>
                If groups are not appearing in the token, enable{" "}
                <strong>Fetch groups via Okta Groups API</strong> below and provide your Okta
                Domain.
              </li>
            </ol>
          </AlertDescription>
        </CollapsibleContent>
      </Collapsible>
    </Alert>
  );
};
